import React from "react";
import { Typography, Row, Col } from "antd";
import { LoadScript, GoogleMap, Marker } from "@react-google-maps/api";
import ReactPlayer from "react-player";
import CustomHeader2 from "../Header/CustomHeader2";
import { Footers } from "../../Footers";

const { Title, Paragraph } = Typography;

const containerStyle = {
  width: "100%",
  height: "400px",
  borderRadius: "8px",
};

// Koordinat Bojonggede
const center = {
  lat: -7.1850945,
  lng: 112.6413619,
};

const lightMapStyle = [
  // ... (style tetap sama seperti sebelumnya)
];

const mapOptions = {
  styles: lightMapStyle,
  disableDefaultUI: true,
  zoomControl: true,
};

const AboutPage = () => {
  return (
    <>
      <CustomHeader2 />
      <div style={{ padding: "40px 5vw" }}>
        <Row gutter={[48, 24]} align="middle">
          {/* Info Section */}
          <Col xs={24} md={12}>
            <div>
              <Title level={2}>PT. LANGGENG BUANA JAYA</Title>
              <Paragraph>
                JL. Veteran Madya No. 8, Kel. Gending, Kec. Kebomas
                Gresik 61123, East Java
                INDONESIA
              </Paragraph>
              
              <Paragraph>+62 31 398 7888</Paragraph>
              <Paragraph>
                {/* <a href="mailto:sales@lbjid.com">sales@lbjid.com</a><br/> */}
                <a href="mailto:customerservice@ptlbj.com">customerservice@ptlbj.com</a>
              </Paragraph>
            </div>
          </Col>
 
          {/* Google Maps */}
          <Col xs={24} md={12}>
            <LoadScript googleMapsApiKey="AIzaSyAQZMoWdRy3nvUv3HedDmjuZ6Zc4VD675c">
              <GoogleMap
                mapContainerStyle={containerStyle}
                center={center}
                zoom={15}
                options={mapOptions}
              >
                <Marker position={center} />
              </GoogleMap>
            </LoadScript>
          </Col>
        </Row>

        {/* YouTube Section */}

        {/* <div style={{ marginTop: "48px" }}>
          <Title level={3}>LBJ Preview</Title>
          <ReactPlayer
            src="https://youtu.be/_cO8kNDdOgU"
            width="100%"
            height="400px"
          />
        </div> */}
      </div>
      <Footers />
    </>
  );
};

export default AboutPage;
